import { render, staticRenderFns } from "./GalasysConnection.vue?vue&type=template&id=fb156dfc&scoped=true"
import script from "./GalasysConnection.vue?vue&type=script&lang=js"
export * from "./GalasysConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb156dfc",
  null
  
)

export default component.exports